import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {EnvironmentService} from '../services/environment.service';
import {HttpClient} from '@angular/common/http';
import {Conversation} from '../models/Conversation';
import {Payment} from '../models/Payment';
import {ConversationDto} from '../interfaces/dto/conversation.dto';
import {map} from 'rxjs/operators';
import {PaymentDto} from '../interfaces/dto/payment.dto';
import {ConversationAdapter} from '../adapters/conversation.adapter';
import {PaymentAdapter} from '../adapters/payment.adapter';
import {ConversationsFilterDto} from '../interfaces/dto/conversations-filter.dto';
import {PaymentFilterDto} from '../interfaces/dto/payment-filter.dto';
import {ClientAdapter} from '../adapters/client.adapter';
import {MessageAdapter} from '../adapters/message.adapter';
import { Message } from '../models/Message';
import { MessageDto } from '../interfaces/dto/message.dto';

@Injectable({
  providedIn: 'root'
})

export class SearchService {
  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient,
    private conversationAdapter: ConversationAdapter,
    private paymentAdapter: PaymentAdapter,
    private clientAdapter: ClientAdapter,
    private messageAdapter: MessageAdapter,
  ) { }

  doConversationSearch(
    searchString: string,
    filters: ConversationsFilterDto,
    practiceId?: string
  ): Observable<{ conversations: Conversation[], total: number }> {
    if (!practiceId) {
      return of({conversations: [], total: 0});
    }

    let url = this.environmentService.get('backendUrl') + '/search/conversations/';
    url += encodeURIComponent(searchString);

    return this.http.post<{ conversations: ConversationDto[], total: number }>(url, {practiceId, filters}, {withCredentials: true}).pipe(
      map((response: { conversations: ConversationDto[], total: number }) => {
        return {
          conversations: response.conversations.map((item) => this.conversationAdapter.run(item)),
          total: response.total
        };
      })
    );
  }

  doPaymentSearch(
    searchString: string,
    filters: PaymentFilterDto,
    practiceId?: string
  ): Observable<{ payments: Payment[], total: number }> {
    if (!practiceId) {
      return of({payments: [], total: 0});
    }

    let url = this.environmentService.get('backendUrl') + '/search/payments/';
    url += encodeURIComponent(searchString);

    return this.http.post<{ payments: PaymentDto[], total: number }>(url, {practiceId, filters}, {withCredentials: true}).pipe(
      map((response: { payments: PaymentDto[], total: number }) => {
        return {
          payments: response.payments.map((item) =>
            this.paymentAdapter.run(
              item,
              item.client ? this.clientAdapter.run(item.client) : undefined
            )
          ),
          total: response.total
        };
      })
    );
  }
  doMessageSearch(
    searchString: string,
    filters: any,
    practiceId?: number,
    page: number = 1,
    limit: number = 20
  ): Observable<{messages: Message[], total: number, page: number, limit: number, totalPages: number}>{
    if (!practiceId) {
      return of({messages: [], total: 0, page: 1, limit: 20, totalPages: 0});
    }

    let url = this.environmentService.get('backendUrl') + '/messages/search/';
    url += encodeURIComponent(searchString);
    url += `?page=${page}&limit=${limit}`;

    const requestBody = {
      practiceId,
      ...filters
    };

    return this.http.post<{
      results: { type: string, data: MessageDto }[],
      total: number,
      page: number,
      limit: number,
      totalPages: number
    }>(url, requestBody, {withCredentials: true}).pipe(
      map((response: {
        results: { type: string, data: MessageDto }[],
        total: number,
        page: number,
        limit: number,
        totalPages: number
      }) => {

        const result = {
          messages: response.results.map((item) => this.messageAdapter.run({...item.data,messageType:item.type})),
          total: response.total,
          page: response.page || 1,
          limit: response.limit || 20,
          totalPages: response.totalPages || 0
        };
        return result;
      })
    );
  }
}
